
import React from 'react';

export function useFestivalFormState() {
  // Festival specific states
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [frequency, setFrequency] = React.useState('');
  const [ticketPrice, setTicketPrice] = React.useState('');
  const [categories, setCategories] = React.useState('');
  const [capacity, setCapacity] = React.useState('');
  const [familyFriendly, setFamilyFriendly] = React.useState(false);
  const [hasFood, setHasFood] = React.useState(false);

  const resetFestivalFormState = () => {
    setStartDate('');
    setEndDate('');
    setFrequency('');
    setTicketPrice('');
    setCategories('');
    setCapacity('');
    setFamilyFriendly(false);
    setHasFood(false);
  };

  return {
    startDate, setStartDate,
    endDate, setEndDate,
    frequency, setFrequency,
    ticketPrice, setTicketPrice,
    categories, setCategories,
    capacity, setCapacity,
    familyFriendly, setFamilyFriendly,
    hasFood, setHasFood,
    resetFestivalFormState
  };
}
